export const queries = [
  {
    activeKey: 'historico',
    sql: `SELECT
                co_seq_fat_cad_individual as id, nu_cpf_cidadao as cpf,
                tfci.dt_nascimento,
                nu_micro_area,
                tfci.nu_cns as cns, TO_CHAR(tdt.dt_registro, 'DD/MM/YYYY') as dt_registro,
                case when st_ficha_inativa = 1 then 'Sim' Else '' end as ficha_inativa,
                case when st_gerado_automaticamente = 1 then 'Sim' Else '' end as ficha_automatica,
                tdtsc.ds_dim_tipo_saida_cadastro as situacao,
                tdp.no_profissional as prof_cadastrante,
                tde.nu_ine,
                tde.no_equipe

                from tb_fat_cad_individual tfci

                left join tb_dim_tipo_saida_cadastro tdtsc
                on tdtsc.co_seq_dim_tipo_saida_cadastro = tfci.co_dim_tipo_saida_cadastro

                left join tb_dim_tempo tdt
                on tdt.co_seq_dim_tempo = tfci.co_dim_tempo

                left join tb_dim_profissional tdp
                on tfci.co_dim_profissional = tdp.co_seq_dim_profissional

                left join tb_dim_equipe tde
                on tfci.co_dim_equipe = tde.co_seq_dim_equipe

                where nu_cpf_cidadao = :cpf or tfci.nu_cns = :cns

                order by co_dim_tempo desc;`,
    params: ['cpf', 'cns'],
    map: ({ cidadao }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns: cidadao?.nu_cns || null,
    }),
  },
  {
    activeKey: 'duplicados',
    sql: `SELECT id, id_master, nu_cpf, nu_cns, no_cidadao, dt_nascimento, no_mae, no_pai, duplicado
                FROM cdds
                WHERE id IN (:id, :id_master) OR id_master IN (:id, :id_master)`,
    params: ['id', 'id_master'],
    map: ({ cidadao }) => ({
      id: cidadao?.id || null,
      id_master: cidadao?.id_master || null,
    }),
  },
  {
    activeKey: 'unificacoes',
    sql: `SELECT cdd_grp.id, cdd_grp.cfcp, co_fat_cidadao_pec as id_dw, id_cidadao as id_pec,
            id_cidadao_master as id_master, id_cidadao_unificado as id_unificado,
            cns, cpf, date(dt_atualizacao) as dt_atualizacao
            FROM cdd_grp
            WHERE cpf = :cpf OR cns = :cns;`,
    params: ['cpf', 'cns'],
    map: ({ cidadao }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns: cidadao?.nu_cns || null,
    }),
  },
  {
    activeKey: 'atendimentos',
    sql: `SELECT tfai.co_seq_fat_atd_ind as id, tfai.cfcp, tfai.nu_cpf_cidadao as cpf, tfai.nu_cns as cns,
           tdta.dt_registro as dt_atendimento,
           tfai.dt_nascimento,
           tfai.nu_peso,
           tfai.nu_altura,
          case when tfai.nu_pressao_sistolica is not null and nu_pressao_diastolica is not null
          then concat(tfai.nu_pressao_sistolica, '/', nu_pressao_diastolica) else null end as pa,

           to_jsonb(array_remove(ARRAY[

           case when tfai.nu_idade_gestacional_semanas is not null then concat('IG: ', tfai.nu_idade_gestacional_semanas) end,
           case when tdtd.dt_registro <> '3000-12-31' then concat('DUM: ', tdtd.dt_registro) end,

                case when  tfai.ds_filtro_proced_avaliados LIKE ANY (ARRAY['%|0201020033|%','%|ABPG010|%', '%|ABX001|%', '%|0203010086|%']) then 'Avaliação citológico' end,

                case when tfai.ds_filtro_proced_solicitados LIKE ANY (ARRAY['%|ABEX008|%', '%|0202010503|%']) then 'Solicitação hemoglobina' end,

                case when tfai.ds_filtro_proced_avaliados LIKE ANY (ARRAY['%|0202031179|%', '%|0214010074|%', '%|0214010082|%', '%|0214010252|%', '%|0202031098|%', '%|0202031110|%', '%|ABEX019|%', '%|ABPG026|%'])
                then 'Avaliacao exame sifilis' end,

                case when tfai.ds_filtro_proced_avaliados LIKE ANY (ARRAY['%|0214010040|%', '%|0214010058|%', '%|0214010279|%',  '%|0213010780|%', '%|0213010500|%', '%|ABEX018|%', '%|ABPG024|%'])
                then 'Avaliacao exame hiv' end

            ], NULL)
  || COALESCE(pa.grupo_cid_ciap, ARRAY[]::text[])
            ) as tipo,
tde.nu_ms,
            tdc.nu_cbo,
            tdc.no_cbo,
            tde.nu_ine,
            tde.no_equipe


       FROM tb_fat_atendimento_individual tfai

       left join tb_dim_tempo tdta
        on tdta.co_seq_dim_tempo = tfai.co_dim_tempo

        left join tb_dim_tempo tdtd
        on tdtd.co_seq_dim_tempo = tfai.co_dim_tempo_dum

        left join tb_dim_equipe tde
        on tde.co_seq_dim_equipe = tfai.co_dim_equipe_1

        left join tb_dim_cbo tdc
        on tfai.co_dim_cbo_1 = tdc.co_seq_dim_cbo

LEFT JOIN (SELECT  tfaip.co_fat_atd_ind,
array_agg(DISTINCT REPLACE(gsc.id_grupo, '_', ' ')) as grupo_cid_ciap
FROM tb_fat_atd_ind_problemas tfaip

JOIN grupo_condicao_saude gsc
ON tfaip.co_dim_ciap = gsc.co_dim_ciap
OR tfaip.co_dim_cid = gsc.co_dim_cid
WHERE  (
COALESCE(tfaip.co_dim_situacao_problema, 0) <> 3
OR COALESCE(tfaip.co_sequencial_evolucao, 0) < 2
)
AND gsc.st_ativo = 1
GROUP BY tfaip.co_fat_atd_ind

) pa ON pa.co_fat_atd_ind = tfai.co_seq_fat_atd_ind


        WHERE tfai.nu_cpf_cidadao = :cpf OR tfai.nu_cns IN :cns_list

       order by tfai.co_dim_tempo desc`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'odonto',
    sql: `SELECT tfao.co_seq_fat_atd_odnt as id, tfao.nu_cpf_cidadao as cpf, tfao.nu_cns as cns,
            tfao.dt_nascimento,
tfao.cfcp, tdt.dt_registro as dt_atendimento,

tdc.nu_cbo,
tdc.no_cbo,
tde.nu_ine,
tde.no_equipe,
tde.nu_ms,

            to_jsonb(array_remove(ARRAY[

            case when tdtco.nu_identificador <> '-' then tdtco.ds_tipo_consulta_odonto end,
            case when tfao.st_gestante = 1 then 'Gestante' end
            ],
            NULL
            ) ) as tipo

            FROM tb_fat_atendimento_odonto tfao

            left JOIN tb_dim_tipo_consulta_odonto tdtco
            ON tfao.co_dim_tipo_consulta = tdtco.co_seq_dim_tipo_cnsulta_odonto

            left join tb_dim_tempo tdt
            on tdt.co_seq_dim_tempo = tfao.co_dim_tempo

left join tb_dim_equipe tde
on tde.co_seq_dim_equipe = tfao.co_dim_equipe_1

left join tb_dim_cbo tdc
on tfao.co_dim_cbo_1 = tdc.co_seq_dim_cbo


            WHERE  tfao.nu_cpf_cidadao = :cpf OR tfao.nu_cns IN :cns_list;`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'vacinas',
    sql: `SELECT
                tfv.cfcp,
                tfv.nu_cpf_cidadao as cpf,
                tfv.nu_cns as cns,
                tfv.dt_nascimento,
                tds.ds_sexo,
                tdt.dt_registro as dt_aplicacao,
                tdta.dt_registro as dt_atendimento,
                tddi.no_dose_imunobiologico as no_dose_imuno,
                tdi.no_imunobiologico as no_imuno,
                case when st_registro_anterior = 1 then 'Sim' else '' end as dose_anterior

                FROM tb_fat_vacinacao tfv

                left join tb_fat_vacinacao_vacina tfvv
                on tfvv.co_fat_vacinacao = tfv.co_seq_fat_vacinacao

                left join tb_dim_dose_imunobiologico tddi
                on tddi.co_seq_dim_dose_imunobiologico = tfvv.co_dim_dose_imunobiologico

                left join tb_dim_imunobiologico tdi
                on tdi.co_seq_dim_imunobiologico = tfvv.co_dim_imunobiologico

                 left join tb_dim_tempo tdta
                 on tdta.co_seq_dim_tempo = tfv.co_dim_tempo

                left join tb_dim_tempo tdt
                --on tdt.co_seq_dim_tempo = tfv.co_dim_tempo
                on tdt.co_seq_dim_tempo = tfvv.co_dim_tempo_vacina_aplicada

                left join tb_dim_sexo tds
                on tds.co_seq_dim_sexo = tfv.co_dim_sexo

                WHERE tfv.nu_cpf_cidadao = :cpf OR tfv.nu_cns IN :cns_list`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'procedimentos',
    sql: `SELECT tfpap.co_seq_fat_proced_atend_proced as id, tfpap.cfcp, tfpap.nu_cpf_cidadao as cpf,
            tfpap.dt_nascimento,
         tfpap.nu_cns as cns, tdt.dt_registro as dt_procedimento,
            tdp.co_proced, tdp.ds_proced,
            0 as st_proced_odonto

            from tb_fat_proced_atend_proced tfpap

            left join tb_dim_tempo tdt
            on tdt.co_seq_dim_tempo = tfpap.co_dim_tempo

            left join tb_dim_procedimento tdp
            on tfpap.co_dim_procedimento = tdp.co_seq_dim_procedimento

            WHERE tfpap.nu_cpf_cidadao = :cpf OR tfpap.nu_cns IN :cns_list

            UNION ALL

        SELECT tfaop.co_seq_fat_atend_odonto_proced as id, tfaop.cfcp, tfaop.nu_cpf_cidadao as cpf,
            null as dt_nascimento,
         tfaop.nu_cns as cns, tdt.dt_registro as dt_procedimento,
            tdp.co_proced, tdp.ds_proced,
           1 as st_proced_odonto

            FROM tb_fat_atend_odonto_proced tfaop

            left join tb_dim_tempo tdt
            on tdt.co_seq_dim_tempo = tfaop.co_dim_tempo

            left join tb_dim_procedimento tdp
            on tfaop.co_dim_procedimento = tdp.co_seq_dim_procedimento

            WHERE tfaop.nu_cpf_cidadao = :cpf OR tfaop.nu_cns IN :cns_list`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'visitas',
    sql: `SELECT cfcp, nu_cpf_cidadao as cpf, tfvd.nu_cns as cns,
                        tdt.dt_registro AS dt_visita,
                        nu_peso,
                        nu_altura,
                        nu_medicao_pressao_arterial as pa,
                        tddv.ds_desfecho_visita AS desfecho,
                        tdp.no_profissional,

                        to_jsonb(array_remove(ARRAY[

                        case when st_mot_vis_cad_att = 1 then 'Cadastro' end,
                        case when st_mot_vis_visita_periodica = 1 then 'Periódica' end,

                        case when st_mot_vis_busca_ativa = 1 then 'Busca ativa' end,
                        case when st_busca_ativa_consulta = 1 then 'Consulta' end,
                        case when st_busca_ativa_exame = 1 then 'Exame' end,
                        case when st_busca_ativa_vacina = 1 then 'Vacina' end,
                        case when st_busca_ativa_bolsa_familia = 1 then 'Bolsa Família' end,

                        case when st_mot_vis_acompanhamento = 1 then 'Acompanhamento' end,
                        case when st_acomp_gestante = 1 then 'Gestante' end,
                        case when st_acomp_puerpera = 1 then 'Puérpera' end,
                        case when st_acomp_recem_nascido = 1 then 'Recém-nascido' end,
                        case when st_acomp_crianca = 1 then 'Criança' end,
                        case when st_acomp_pessoa_desnutricao = 1 then 'Desnutrição' end,
                        case when st_acomp_pessoa_reabil_deficie = 1 then 'Reabilitação ou Deficiência' end,
                        case when st_acomp_pessoa_hipertensao = 1 then 'Hipertensão' end,
                        case when st_acomp_pessoa_diabetes = 1 then 'Diabetes' end,
                        case when st_acomp_pessoa_asma = 1 then 'Asma' end,
                        case when st_acomp_pessoa_dpoc_enfisema = 1 then 'DPOC/enfisema' end,
                        case when st_acomp_pessoa_cancer = 1 then 'Câncer' end,
                        case when st_acomp_pessoa_doenca_cronica = 1 then 'Outras doenças crônicas' end,
                        case when st_acomp_pessoa_hanseniase = 1 then 'Hanseníase' end,
                        case when st_acomp_pessoa_tuberculose = 1 then 'Tuberculose' end,
                        case when st_acomp_sintomaticos_respirat = 1 then 'Sintomáticos respiratórios' end,
                        case when st_acomp_tabagista = 1 then 'Tabagista' end,
                        case when st_acomp_domiciliados_acamados = 1 then 'Domiciliados/Acamados' end,
                        case when st_acomp_condi_vulnerab_social = 1 then 'Vulnerabilidade social' end,
                        case when st_acomp_condi_bolsa_familia = 1 then 'Bolsa Família' end,
                        case when st_acomp_saude_mental = 1 then 'Saúde mental' end,
                        case when st_acomp_usuario_alcool = 1 then 'Álcool' end,
                        case when st_acomp_usuario_outras_drogra = 1 then 'Outras drogas' end,
                        case when st_acomp_pessoa_idosa = 1 then 'Pessoa idosa' end,


                        case when st_mot_vis_ctrl_ambnte_vetor = 1 then 'Controle ambiental/vetorial' end,
                        case when st_ctrl_amb_vet_acao_educativa = 1 then 'Ação educativa' end,
                        case when st_ctrl_amb_vet_imovel_foco = 1 then 'Imóvel com foco' end,
                        case when st_ctrl_amb_vet_acao_mecanica = 1 then 'Ação mecânica' end,
                        case when st_ctrl_amb_vet_tratamnt_focal = 1 then 'Tratamento focal' end,


                        case when st_mot_vis_egresso_internacao = 1 then 'Egresso de Internação' end,
                        case when st_mot_vis_convte_atvidd_cltva = 1 then 'Convite atividades coletivas' end,
                        case when st_mot_vis_orintacao_prevncao = 1 then 'Orientação/prevenção' end,
                        case when st_mot_vis_outros = 1 then 'Outros' end
                        ],
                        NULL
                        )) as motivo_acomp

                        FROM tb_fat_visita_domiciliar tfvd


                        left join tb_dim_tempo tdt
                        on tdt.co_seq_dim_tempo = tfvd.co_dim_tempo

                        left join tb_dim_profissional tdp
                        on tfvd.co_dim_profissional = tdp.co_seq_dim_profissional

                        left join tb_dim_desfecho_visita tddv
                        on tddv.co_seq_dim_desfecho_visita = tfvd.co_dim_desfecho_visita


                        WHERE tfvd.nu_cpf_cidadao = :cpf OR tfvd.nu_cns IN :cns_list`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'problemas',
    sql: `SELECT DISTINCT ON (tfaip.nu_uuid_problema)
                        tfaip.nu_cpf_cidadao,
                        tfaip.nu_cns,
                        REPLACE(coalesce(gsc.id_grupo, 'VER_NO_PEC'), '_', ' ') AS id_grupo,
                        tfaip.nu_uuid_problema,
                        tdsp.ds_situacao_problema,
                        to_date(tfaip.co_dim_data_inicio_problema::text, 'YYYYMMDD') AS dt_inicio,
                        to_date(tfaip.co_dim_data_fim_problema::text,    'YYYYMMDD') AS dt_fim,
                        to_date(tfaip.co_dim_tempo::text,                'YYYYMMDD') AS dt_evolucao
                    FROM tb_fat_atd_ind_problemas AS tfaip

                    LEFT JOIN tb_dim_situacao_problema AS tdsp
                        ON tdsp.co_seq_dim_situacao = tfaip.co_dim_situacao_problema

                    JOIN grupo_condicao_saude AS gsc
                        ON gsc.co_dim_ciap = tfaip.co_dim_ciap
                            OR gsc.co_dim_cid = tfaip.co_dim_cid

                    WHERE tfaip.nu_cpf_cidadao = :cpf OR tfaip.nu_cns IN :cns_list

                    ORDER BY
                        tfaip.nu_uuid_problema,
                        tfaip.co_dim_situacao_problema DESC;`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
  {
    activeKey: 'exames',
    sql: `SELECT * from (SELECT
                        tdt.dt_registro AS dt_atendimento,
                        tfaip.nu_cns,
                        tfaip.nu_cpf_cidadao,

                        tdc.nu_cbo,
                        tdc.no_cbo,
                        tde.nu_ine,
                        tde.no_equipe,
                        tde.nu_ms,


case when tfaip.co_dim_procedimento_solicitado <> 1 then tdps.co_proced else tdpa.co_proced end as co_proced,
case when tfaip.co_dim_procedimento_solicitado <> 1 then tdps.ds_proced else tdpa.ds_proced end as ds_proced,

    case when tfaip.co_dim_procedimento_solicitado <> 1 then 'Solicitado' else 'Avaliado' end as st_proced

                    FROM tb_fat_atd_ind_procedimentos tfaip

                    LEFT JOIN tb_dim_tempo tdt ON tdt.co_seq_dim_tempo = tfaip.co_dim_tempo

                    LEFT JOIN tb_dim_procedimento tdpa
                    ON tfaip.co_dim_procedimento_avaliado = tdpa.co_seq_dim_procedimento

                    LEFT JOIN tb_dim_procedimento tdps
                    ON tfaip.co_dim_procedimento_solicitado = tdps.co_seq_dim_procedimento

                    LEFT JOIN tb_dim_equipe tde
                    ON tde.co_seq_dim_equipe = tfaip.co_dim_equipe_1

                    left join tb_dim_cbo tdc
                    on tfaip.co_dim_cbo_1 = tdc.co_seq_dim_cbo

                    WHERE tfaip.nu_cpf_cidadao = :cpf OR tfaip.nu_cns IN :cns_list
                    ) tb_tempo order by co_proced, dt_atendimento asc`,
    params: ['cpf', 'cns_list'],
    map: ({ cidadao, cnsList }) => ({
      cpf: cidadao?.nu_cpf || null,
      cns_list: cnsList || [],
    }),
  },
]
